import { Badge } from "@shopify/polaris";

function StatusBadge({ status }) {
  if (!status) return;
  switch (status) {
    case "awaiting_provider":
      return <Badge tone="info">Esperando proveedor</Badge>;
    case "awaiting_invoice":
      return <Badge tone="attention">Falta factura</Badge>;
    case "pending_approval":
      return <Badge tone="warning">En Revisión</Badge>;
    case "payment_pending":
      return <Badge tone="attention">Falta Pago</Badge>;
    case "denied":
      return <Badge tone="critical">Negado</Badge>;
    case "partially_paid":
      return <Badge tone="attention">Pago Parcial</Badge>;
    case "paid":
      return <Badge tone="">Pagado</Badge>;
    default:
      return <Badge>NA</Badge>;
  }
}

export default StatusBadge;
